import WOW from "wow.js";
// import "waypoints/lib/jquery.waypoints";
// import "waypoints/lib/shortcuts/inview";

// WOW.prototype.addBox = function(element){
//     this.boxes.push(element);
// };

const wowJs = function () {

    // Init WOW.js and get instance
    let wowObj = new WOW();
    wowObj.init();

    // console.log(wow)

    // const initWowObject = function (waypointElement) {
    //     $(waypointElement).css({
    //         'visibility' : 'hidden',
    //         'animation-name' : 'none'
    //     }).removeClass('animated');
    //     wow.addBox(waypointElement);
    // }

    // if ( $(".wow").length ) {

        // var inviewWow = {};
        // $('.wow').each(function(index) {
        //
        //     inviewWow.index = new Waypoint.Inview({
        //         element: $(this),
        //         enter: function (direction) {
        //             //console.log('enter ' + direction, inviewWow.index.element)
        //             //console.log('Enter triggered with direction ' + direction)
        //         },
        //         entered: function (direction) {
        //             //console.log('entered ' + direction, inviewWow.index.element)
        //             //console.log('Entered triggered with direction ' + direction)
        //         },
        //         exit: function (direction) {
        //             //console.log('exit ' + direction, inviewWow.index.element)
        //             //console.log('Exit triggered with direction ' + direction)
        //             // inview.element.find('video')[0].pause();
        //         },
        //         exited: function (direction) {
        //
        //             // $(inviewWow.index.element).css({
        //             //     'visibility': 'hidden',
        //             //     'animation-name': 'none'
        //             // }).removeClass('animated');
        //             // wowObj.addBox(inviewWow.index.element);
        //
        //             if ($(inviewWow.index.element).hasClass('animated')) {
        //                 $(inviewWow.index.element).removeClass('animated');
        //                 $(inviewWow.index.element).removeAttr('style');
        //                 wowObj.addBox(inviewWow.index.element);
        //                 // new WOW().init();
        //             }
        //
        //             //console.log('exited ' + direction, inviewWow.index.element)
        //             //console.log('Exited triggered with direction ' + direction)
        //         }
        //     });
        // });

        // $('.wow').on('scrollSpy:exit', function() {
        //     $(this).css({
        //         'visibility': 'hidden',
        //         'animation-name': 'none'
        //     }).removeClass('animated');
        //     wow.addBox(this);
        // }).scrollSpy();


        // $('.wow').waypoint(function(direction) {
        //
        //     console.log('Enter triggered with direction ' + direction);
        //     console.log($(this.element))
        //
        //     if ( direction == 'down' ) {
        //
        //         initWowObject(this.element);
        //         //$('.js-header-content').addClass('is--hidden');
        //     } else {
        //         //$('.js-header-content').removeClass('is--hidden');
        //     }
        //
        // }, {
        //     offset: '-10px'
        // })

        // let wowInview = new Waypoint.Inview({
        //     element: $(".wow"),
        //     enter: function (direction) {
        //         console.log(wowInview.element);
        //         console.log('Enter triggered with direction ' + direction);
        //     },
        //     entered: function (direction) {
        //         console.log(wowInview.element);
        //         console.log('Entered triggered with direction ' + direction);
        //     },
        //     exit: function (direction) {
        //         console.log(wowInview.element);
        //         console.log('Exit triggered with direction ' + direction);
        //     },
        //     exited: function (direction) {
        //         console.log(wowInview.element);
        //         console.log('Exited triggered with direction ' + direction);
        //
        //         //initWowObject(wowInview.element);
        //         //var element = $(this);
        //
        //     }
        // });
    // }

}

export default wowJs;